/**
 * @fileOverview 权限验证相关
 * @author: kirkzheng
 * @time: 2016-05-24
 */

import cookie from './cookie';

/**
 * 获取g_tk
 * @return {String} token
 */
export const getACSRFToken = () => {
  const str = cookie.get('gdt_protect') || cookie.get('skey');
  let hash = 5381;
  let i = 0;
  let len = 0;

  i = 0;
  len = str.length;

  for (; i < len; ++i) {
    hash += (hash << 5) + str.charCodeAt(i);
  }

  return hash & 0x7fffffff;
};

/*
 * 文件默认到处
 */
export default {
  getACSRFToken,
};
